import React from 'react';
import { Check, ArrowRight, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-[#2C1810] text-white relative overflow-hidden" data-id="element-102">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-103"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-104">
        <div className="bg-white text-[#2C1810] rounded-3xl shadow-2xl overflow-hidden" data-id="element-105">
          <div className="bg-[#F5A623] p-4 text-center" data-id="element-106">
            <p className="font-bold text-[#2C1810] uppercase tracking-wider" data-id="element-107">
              Oferta Especial de Lanzamiento
            </p>
          </div>

          <div className="p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-108">
            <div data-id="element-109">
              <h3 className="font-heading text-3xl font-bold mb-2" data-id="element-110">
                Cena de 7 Minutos
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-111">La Guía Digital Completa</p>

              <div className="inline-block bg-[#F5A623] text-[#2C1810] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-112">
                🔥 Oferta de lanzamiento — Solo por hoy
              </div>

              <div className="flex items-baseline mb-2" data-id="element-113">
                <span className="text-5xl font-bold text-[#D4522A]" data-id="element-114">$6.39</span>
                <span className="text-xs font-semibold text-gray-500 ml-1 mb-1 self-end" data-id="element-115">
                  USD
                </span>
                <span className="text-gray-400 line-through ml-3 text-xl" data-id="element-116">
                  $27
                </span>
              </div>

              <p className="text-xs text-[#2D6A4F] font-bold mb-6" data-id="element-117">
                ✅ Ahorras $20.61 hoy — precio sube pronto
              </p>

              <p className="text-sm text-gray-600 mb-8" data-id="element-118">
                Menos que un café en Starbucks. Resultados para toda la vida.
              </p>

              <button onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  value: 6.39,
                  currency: 'USD',
                  content_name: 'Cena de 7 Minutos',
                  content_type: 'product'
                });
              }
              window.open('https://rutinasimple.com//cart/52006031393049:1', '_blank');
            }} className="w-full bg-[#D4522A] hover:bg-[#B8401C] text-white font-heading font-bold text-xl py-4 rounded-lg shadow-lg transform transition hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-119">
                DESCARGAR AHORA — $6.39 USD
                <ArrowRight className="w-5 h-5" data-id="element-120" />
              </button>

              <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-121">
                <ShieldCheck className="w-4 h-4" data-id="element-122" />
                <span data-id="element-123">Pago 100% Seguro</span>
              </div>
            </div>

            <div className="bg-[#FDF6EC] p-8 rounded-2xl" data-id="element-124">
              <h4 className="font-bold text-lg mb-4" data-id="element-125">Lo que recibes hoy:</h4>
              <ul className="space-y-3" data-id="element-126">
                <li className="flex items-start gap-3" data-id="element-127">
                  <Check className="w-5 h-5 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-128" />
                  <span className="text-gray-700" data-id="element-129">
                    Guía Digital "Cena de 7 Minutos"
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-130">
                  <Check className="w-5 h-5 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-131" />
                  <span className="text-gray-700" data-id="element-132">
                    Lista de Compras "Latino Pantry"
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-133">
                  <Check className="w-5 h-5 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-134" />
                  <span className="text-gray-700" data-id="element-135">
                    Recetario Express (20 recetas)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-136">
                  <Check className="w-5 h-5 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-137" />
                  <span className="text-gray-700" data-id="element-138">
                    Bonus: Guía de Snacks de Gasolinera
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-139">
                  <Check className="w-5 h-5 text-[#2D6A4F] mt-0.5 flex-shrink-0" data-id="element-140" />
                  <span className="text-gray-700" data-id="element-141">Acceso Inmediato (PDF)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}